// extracted by mini-css-extract-plugin
export default {"item":"List_item__YDq2e","group":"List_group__dDk9J","title":"List_title__Fac+j"};